var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g({attrs:{"color":_vm.statusColor,"text-color":_vm.statusColor,"small":_vm.small,"outlined":""}},_vm.$listeners),[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":_vm.statusColor}},[_vm._v(" "+_vm._s(_vm.statusIcon)+" ")]),_vm._v(" "+_vm._s(_vm.statusText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }